import fetch from 'isomorphic-unfetch'

const _URL_API = process.env.REACT_APP_API_URL
const _URL = process.env.REACT_APP_URL

const URL_API = _URL_API || 'https://api.ihore.id/api'
const URL = _URL || 'https://api.ihore.id'


export const config = {
  baseApi: process.env.NODE_ENV === 'development' ? 'http://127.0.0.1:3333/api' : URL_API,
  baseUrl: process.env.NODE_ENV === 'development' ? URL : URL,
  // 'https://api-primary.tunasmultidata.id',
}

if (typeof window !== 'undefined') {
  const host = window.location.host  // contoh: libre-nms.ihore.id:8090
  if (host === 'libre-nms.ihore.id:8090') {
    config.baseApi = 'http://192.168.180.101:3000/api'
  }
}



export const controller = new AbortController()

export const signal = controller.signal

export const GetToken = () => {
  let tmp = null
  if (typeof localStorage !== 'undefined') {
    tmp = localStorage && localStorage.getItem('authToken')
  } else if (typeof sessionStorage !== 'undefined') {
    tmp = sessionStorage.getItem('authToken');
  } else {
    // If neither localStorage nor sessionStorage is supported
    console.log('Web Storage is not supported in this environment.');
  }


  try {
    // console.log(tmp)
    tmp = tmp && JSON.parse(tmp)
    return tmp
  } catch (error) {
    return null
  }
}

async function generateResFromFetch(res) {
  try {
    const a1 = await res.json()
    return a1
  } catch (error) {
    return null
  }
}

export const request = (method, url, data, responseType, signalController) => {
  // console.log(window.location.host)
  let target_url = config.baseApi

  if (window.location.host === "billing-pkl.sks.net.id") {
    target_url = `https://billing-pkl.sks.net.id/local/api`
  }
  /* agar cors hilang */
  if (window.location.host === "billing.ihore.id") {
    target_url = `https://billing.ihore.id/v2/api`
  }
  if (window.location.host === "axim.ihore.id") {
    target_url = `https://axim.ihore.id/v2/api`
  }
  // console.log(config.baseApi)
  const token = GetToken()
  const _url = `${target_url}${url}`
  /* ganti loginnya agar 1 jam menit saja */
  // console.log(_newToken)

  let _data = data
  // console.log(data)
  /* 
      menunggu yang menggunakan blob :(
    */
  //  console.log(responseType)
  const isFormData = data instanceof FormData

  // if (isFormData) {
  //   _data = Array.from(data.entries()).reduce(
  //     (memo, pair) => ({
  //       ...memo,
  //       [pair[0]]: pair[1],
  //     }),
  //     {},
  //   )
  //   // console.log(_data)
  // }

  return fetch(_url, {
    method,
    signal: signalController?.signal || signal,
    // mode: responseType === 'blob' ? 'no-cors' : 'cors',
    credentials: 'include',
    // credentials: 'same-origin',
    // credentials: 'include'
    // redirect: 'manual',
    headers: new Headers({

      Accept: 'application/json',
      ...(token && {
        Authorization: 'Bearer ' + token?.token,
      }),
      ...(isFormData ? {} : { "Content-Type": "application/json" }),
    }),
    // headers: {

    //   Authorization: `${token ? 'Bearer ' + token.token : null}`,
    // },
    ...(data && {
      body: isFormData ? data : data ? JSON.stringify(data) : undefined,
    }),
  })
    .then(async (res) => {
      const a1 =
        responseType && responseType === 'blob' ? await res.blob() : await generateResFromFetch(res)
      // console.log(a1)
      if (res.ok) {
        return {
          data: a1,
        }
      }
      // eslint-disable-next-line no-throw-literal
      throw {
        response: {
          statusText: res.statusText,
          data: a1,
          status: res.status,
        },
      }
    })

    .catch((err) => {
      throw err
    })
  // console.log(data);
  // return axios({
  //   method,
  //   baseURL: config.baseApi,
  //   url,
  //   data,
  //   headers: { Authorization: `${token ? 'Bearer ' + token.token : null}`,  },
  //   // options are 'arraybuffer', 'blob', 'document', 'json', 'text', 'stream'
  //   options: {
  //     responseType: responseType || 'json'
  //   },
  //   onUploadProgress
  // }).then(res => res)
  //   .catch(async (err) => {
  //     // alert(JSON.stringify(err.response))
  //     // console.log(err)
  //     throw err;
  //   });
}
